<div class="header">
  <p class="fs-14 align-content-center">Cambiar alias de cuenta</p>
  <button mat-button class="invert flat" (click)="cancel()">
    <fa-icon class="fs-14 my-auto" [icon]="close"></fa-icon>
  </button>
</div>

<div class="body">

  <p class="fs-15 m-auto w-90 text-center cl-primary mb-2 pb-2">
    Editar el alias para identificar tu cuenta bancaria
  </p>

  <p class="fs-15 m-auto text-center cl-primary mb-3 pb-2">
    Alias actual: <strong>{{ account.alias }}</strong>
  </p>

  <form [formGroup]="editForm">
    <mnf-input-form flat="1" formControlName="alias" label="Alias" [placeholder]="'Ej: ' + account.alias"
      errMsg="Debe estar lleno éste campo">
    </mnf-input-form>
  </form>

  <div class="d-flex justify-content-center mt-4">
    <button mat-button (click)="updateAlias()">
      Confirmar
    </button>
  </div>

</div>
